import { render, staticRenderFns } from "./copydatapush.vue?vue&type=template&id=37de8cb1&"
import script from "./copydatapush.vue?vue&type=script&lang=ts&"
export * from "./copydatapush.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "copydatapush.vue"
export default component.exports